import GoogleLogo from './GoogleLogo';
export default GoogleLogo;
